import { useMemo } from 'react';
import { IssueRole } from '@momentum/types';
import type {
  IssueWithPermissionCheck,
  IssueWithChildren,
} from '@momentum/types';
import { hasFullPermission } from '@/shared/utils/issue-guards';

/**
 * Hook to check issue permissions for the current user
 * Returns an object with permission flags (canEdit, canDelete, etc.)
 */
export function useIssuePermissions(
  issue: IssueWithPermissionCheck | IssueWithChildren
): {
  canEdit: boolean;
  canDelete: boolean;
} {
  return useMemo(() => {
    if (!hasFullPermission(issue)) {
      return { canEdit: false, canDelete: false };
    }

    const canEdit =
      issue.role === IssueRole.OWNER || issue.role === IssueRole.ASSIGNEE;
    const canDelete = issue.role === IssueRole.OWNER;

    return { canEdit, canDelete };
  }, [issue]);
}
